import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface RemovePayoffConfirmationDocumentArg {
    engagementId: number;
    sourceRowId: number;
}

export const RemovePayoffConfirmationDocument = createAsyncThunk(
    'flowOfFunds/removePayoffConfirmationDocument',
    async (arg: RemovePayoffConfirmationDocumentArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/FlowOfFunds/${arg.engagementId}/WireTransfers/ThirdPartyPayoffs/${arg.sourceRowId}/PayoffConfirmationDocument`
            );

            if (response.status !== 200) {
                throw new Error('Failed to remove the payoff confirmation document');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while removing the payoff confirmation document.',
                'error'
            );
            throw error;
        }
    }
);
